import { ConditionalOperator as o } from "../../../../node_modules/gridify-client/dist/index.esm.js";
import { isCaseSensitive as t } from "./utils/isCaseSensitive.js";
import { isLastValue as i } from "./utils/isLastValue.js";
const e = (o2) => "complex" === o2.type, r = (e2, r2) => {
  const { key: s, op: n, value: a } = e2, d = n ? o[n] : o.Equal;
  return r2.startGroup(), a.forEach((o2, e3) => {
    r2.addCondition(s, d, o2, !t(n)), i(a, e3) || r2.or();
  }), r2.endGroup(), r2;
};
export {
  e as isComplex,
  r as serializeComplex
};
//# sourceMappingURL=serializeComplex.js.map
